<template>
  <div class="preheat">
    <div class="preheatimg">
      <img src="https://musicwow.oss-cn-shenzhen.aliyuncs.com/single_page/activity/match_notice_20201020.jpg" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: 'preheat',
  data () {
    return {
    }
  },
  computed: {
  },
  components: {
  },
  methods: {
  },
  mounted () {
  },
  created () {
  },
  beforecreate(){
  }
}
</script>
<style lang="scss" scoped>
  .preheat{
    padding-bottom:82px;
  }
  .preheatimg img{
    display: block;
  }
  .preheatbottom{
    width: 98%;
    padding:5px 1% 5px 1%;
    background: #ffffff;
    display: flex;
    align-items: center;
    height: 72px;
    position: fixed;
    bottom: 0;
  }
  .closebtn{
    width:8%;
  }
  .logodetails{
    width: 72%;
    display: flex;
    align-items: center;
  }
  .logodetails img{
    width: 54px;
    height:54px;
    margin-right: 10px;
  }
  .details {
    text-align: left;
  }
  .details div:nth-of-type(1){
    font-size: 16px;
    color: #333338;
    margin-bottom:5px;
  }
  .details div:nth-of-type(2){
    font-size: 12px;
    color: #979797;
  }
  .loading{
    color:#07D1AA;
    font-size: 12px;
    width: 20%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>

